import LoadingState from 'components/LoadingState';
import { useHasFollowers } from 'pages/Play/state/useFeedFollowers';
import React from 'react';
import EmptyState from './EmptyState';
import FollowersList from './FollowersList';

type PodcastFollowersProps = {};

const PodcastFollowers: React.FC<PodcastFollowersProps> = () => {
  const { data: hasFollowers, isLoading } = useHasFollowers();

  if (isLoading) {
    return <LoadingState />;
  }

  if (hasFollowers) {
    return <FollowersList />;
  }

  return <EmptyState />;
};

export default PodcastFollowers;
